import { useSelector } from 'react-redux'
import { formatDateFromString } from '../util/helpers'
import { State } from '../reducers'

interface QueryParams {
    perPage?: number
    from?: Date
    to?: Date
}

export const getQueryParams = (params: (keyof QueryParams)[]): QueryParams => {
    const searchParamsRedux = useSelector<State, string>((state) => state.user.search_params)
    const searchParams = new URLSearchParams(searchParamsRedux)

    const result: QueryParams = {}

    params.forEach((p) => {
        if (searchParams.has(p)) {
            const exists = searchParams.get(p)
            if (exists) {
                if (p == 'from' || p == 'to') {
                    result[p] = formatDateFromString(exists)
                } else if (p == 'perPage') {
                    result[p] = parseInt(exists)
                }
            }
        } else {
            result[p] = undefined
        }
    })

    return result
}
